import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { base_url } from '../api/index';
import AccessDenied from './AccessDenied';
import { useI18n } from '../i18n/I18nContext';

const getHeaders = () => ({
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

interface TableData {
    id: number | string;
    name?: string;
    [key: string]: unknown;
}

interface MasaBirlesdirProps {
    tableItemData: TableData;
    /** Uğurdan sonra modalı bağlamaq üçün. Verilməsə səhifə yenilənir. */
    onDone?: () => void;
}

const MasaBirlesdir: React.FC<MasaBirlesdirProps> = ({ tableItemData, onDone }) => {
    const { t } = useI18n();
    const [availableTables, setAvailableTables] = useState<TableData[]>([]);
    const [selectedTable, setSelectedTable] = useState<string>('');
    const [accessDenied, setAccessDenied] = useState<boolean>(false);

    useEffect(() => {
        const fetchAvailableTables = async () => {
            try {
                const response = await axios.get(`${base_url}/tables`, {
                    ...getHeaders(),
                    params: {
                        is_available: 0
                    },
                });
                
                // Filter out the current table from the available tables
                const filteredTables = response.data.tables.filter((table: TableData) => table.id !== tableItemData.id);
                setAvailableTables(filteredTables);
            } catch (error: any) {
                console.error('Error fetching available tables:', error);
            }
        };

        fetchAvailableTables();
    }, [tableItemData.id]);

    const handleChangeTable = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (selectedTable) {
            try {
                await axios.post(`${base_url}/tables/${tableItemData.id}/merge-table`, {
                    table_id: selectedTable
                }, getHeaders());
                
                // Handle successful response if needed
                alert(t('modal.mergeSuccess'));
                // Tam səhifə yeniləməsi POS-da 1-3 saniyə ağ ekran deməkdir.
                // Masa grid-i onsuz da realtime-dır — pos_local WS
                // "orders.OrderMerged" yayır, ona görə modalı bağlamaq bəsdir.
                if (onDone) onDone();
                else window.location.reload();
            } catch (error: unknown) {
                if (axios.isAxiosError(error) && error.response && error.response.status === 403 && error.response.data.message === "Forbidden") {
                    setAccessDenied(true); // Set access denied if response status is 403
                } else {
                   
                    console.error('Error changing table:', error);
                    alert(t('modal.mergeError'));
                }
            }
        }
    };
    if (accessDenied) return <AccessDenied onClose={() => setAccessDenied(false)} />;
    return (
        <form onSubmit={handleChangeTable}>
            <div className='border rounded bg-gray-50 m-4 p-3'>
                <h3 className='mb-3'>{t('modal.mergeTitle')}</h3>
                <p className='text-red-500 mb-1'>{t('modal.mergeNote')}</p>
                <div className='flex items-center mb-3'>
                    <select
                        className='form-item w-full'
                        name="targetTable"
                        id="targetTable"
                        value={selectedTable}
                        onChange={(e) => setSelectedTable(e.target.value)}
                        required
                    >
                        <option value="">{t('modal.selectTable')}</option>
                        {availableTables.map(table => (
                            <option key={table.id} value={table.id}>
                                {table.name || t('modal.noName')}
                            </option>
                        ))}
                    </select>
                </div>
                <button className='block bg-sky-600 font-medium py-2 px-4 rounded text-white'>{t('common.save')}</button>
            </div>

        </form>
    )
}

export default MasaBirlesdir

